import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Contact: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('message', formData.message);
    
    try {
      const response = await fetch('https://formspree.io/f/xyybvqgp', {
        method: 'POST',
        body: formDataToSend,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: '', email: '', message: '' });
      } else {
        const errorData = await response.json();
        console.error('Formspree error:', errorData);
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Hiba történt az üzenet küldése során. Kérjük, próbálja újra.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const contactDetails = [
    { icon: <FaPhone />, text: 'Nagy Péter Villanyszerelő mester', phone: '+36703620652' },
    { icon: <FaPhone />, text: 'Tamasi Krisztán villamosbiztonsági felülvizsgáló', phone: '+36706049889' },
    { icon: <FaEnvelope />, text: 'kelectrokft@gmail.com', link: 'mailto:kelectrokft@gmail.com' },
    { icon: <FaMapMarkerAlt />, text: 'SZOLNOK és 100km-es körzete' }
  ];

  return (
    <section id="contact" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">
          Lépjen kapcsolatba velünk
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div className="space-y-6 bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Elérhetőségeink</h3>
            {contactDetails.map((item, index) => (
              <div key={index} className="flex items-center space-x-4 group hover:bg-white p-4 rounded-xl transition-all duration-300">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                <div className="text-gray-700">
                  {item.phone ? (
                    <div>
                      <div className="text-lg font-medium">{item.text}</div>
                      <a 
                        href={`tel:${item.phone}`}
                        className="text-red-600 hover:text-red-800 font-semibold transition-colors"
                      >
                        {item.phone}
                      </a>
                    </div>
                  ) : item.link ? (
                    <a 
                      href={item.link}
                      className="text-lg hover:text-red-600 transition-colors"
                    >
                      {item.text}
                    </a>
                  ) : (
                    <span className="text-lg">{item.text}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
          
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            {submitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-4">
                  ✓
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 mb-2">Köszönjük!</h3>
                <p className="text-gray-600 mb-4">Üzenetét sikeresen megkaptuk. Hamarosan felvesszük Önnel a kapcsolatot.</p>
                <button 
                  onClick={() => setSubmitted(false)}
                  className="text-red-600 hover:text-red-800 font-medium transition-colors"
                >
                  Új üzenet küldése
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block mb-2 text-gray-700 font-medium">Név</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-600/20 focus:border-red-600 transition-all duration-300 text-gray-800 placeholder-gray-500"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block mb-2 text-gray-700 font-medium">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-600/20 focus:border-red-600 transition-all duration-300 text-gray-800 placeholder-gray-500"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block mb-2 text-gray-700 font-medium">Üzenet</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-600/20 focus:border-red-600 transition-all duration-300 h-32 resize-none text-gray-800 placeholder-gray-500"
                    required
                  />
                </div>
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-red-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-red-700 transform hover:scale-105 transition-all duration-300 hover:shadow-[0_0_30px_rgba(220,38,38,0.3)] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                >
                  {isSubmitting ? 'Küldés...' : 'Üzenet küldése'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;